<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>

      <!--  ROW    -->
      <div class="vx-row mb-1" >
        <div class="vx-col  w-full">
          <vs-input
            v-on:keydown.enter="createRank"
            class="w-full my-2"
            label="Name"
            v-model="newRank.name"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full my-2 mb-2">
          <vs-button class="mx-1 w-full" @click="createRank">Create Rank</vs-button>
        </div>
      </div>

    </div>


</template>

<script>
  import types from '@/models';
  import api from '@/http/api';

  export default {
    data() {
      return {
        newRank: new types.CompanyRank(),
      }
    },
    props: {
      company: {
        type: types.Company(),
        required: true,
        default: () => {
          return new types.Company()
        }
      },
      order: {
        type: Number,
        required: true,
        default: () => {
          return 100;
        }
      },
    },
    methods: {
      async createRank() {
        this.$vs.loading();
        this.newRank.company_id = this.company.company_id;
        this.newRank.order = this.order + 1;

        let newRank = await api.createCompanyRank(this.newRank);
        // console.log(newRank);
        this.$vs.loading.close();

        if (newRank === null) {
          this.showNotification(false, 'error creating rank');
          return;
        }

        this.$emit('rankCreated', newRank);

      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    }
  }
</script>

<style lang="css" scoped>
</style>
